<template>

  <div class="card-base card-shadow--medium widget small-widget queue-widget">
    <div class="widget-value ph-10">
      <div class="flex mb-10 mt-10 align-center">
        <span class="mr-5 flex justify-center align-center">
          <v-svg width="18" height="18" class="voxo-yellow" sprite="clock"/>
        </span>
        <el-input
          class="widget-name-input ml-10"
          v-model="widgetName"
        />
        <el-button
          @click="removeWidget"
          class="table-action-button ml-10"
        >
          <i class="el-icon-delete voxo-dark-red" />
        </el-button>
      </div>
    </div>

    <div class="ph-10 flex">
      <el-input
        class="widget-search-input"
        v-model="searchText"
        placeholder="Search queue"
        clearable
        style="margin-right: 0;"
      >
        <template slot="prefix">
          Queue
        </template>
      </el-input>
    </div>

    <div class="table-widget-table ph-10">
      <vxe-grid
        round
        height="100%"
        border="inner"
        ref="xGrid"
        class="user-stats-table"
        empty-text="No Data"
        auto-resize
        :show-overflow="true"
        :scroll-y="{enabled: true, gt: 25, oSize: 0}"
        :sort-config="{defaultSort: {field: 'holdTime', order: 'desc'}}"
        :data="tableData"
        :columns="activeColumns"
      />
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";
import {debounce} from 'lodash';
import {apiV2Host} from "@/feathers/feathers-client";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: 'QueueWaitingTable',
  props: {
    widgetIndex: {required: true},
    title: {required: true},
    queueNameKey: {required: true},
    columnFields: {required: true},
  },
  data() {
    return {
      widgetName: this.title,
      searchText: '',
      filter: '',
      viewStyle: 'default',
      tableColumns: [
        {
          field: 'queueId',
          title: 'Queue',
          minWidth: 175,
          sortable: true,
          formatter: this.getQueueName,
        },
        {
          field: 'holdTime',
          title: 'Wait Time',
          minWidth: 100,
          sortable: true,
          sortBy: (data) => data.holdTime,
          formatter: this.timeFormatter
        },
        {
         field: 'callerName',
         title: 'Name',
         minWidth: 175,
         sortable: true
        },
        {
          field: 'callerNum',
          title: 'Phone',
          minWidth: 175,
          formatter: this.numberFormatter
        },
      ],
      actionColumn: {
        field: 'callPickup',
        title: "",
        width: 75,
        slots: {
          default: ({row}) => {
            return [
              <el-tooltip placement="top" content="Pick up" v-show={!row.channel.includes('Local')}>
                <el-button
                  onClick={() => this.withdrawCaller(row)}
                  class="table-action-button icon-green"
                >
                  <v-svg sprite="call-bounce" className="voxo-green"/>
                </el-button>
              </el-tooltip>
            ]
          },
        }
      }
    }
  },
  computed: {

    ...mapGetters('queueDashWaiting', {waitingCallData: 'list'}),

    tableData() {

      if(this.filter) {
        return this.waitingCallData.filter(item => {
          return this.queueNameKey[item.queueId].toLowerCase().includes(this.filter.toLowerCase());
        });
      }

      return this.waitingCallData;
    },

    activeColumns() {
      if(this.isQueueAdmin && this.canWithdrawCallers){
        return [this.actionColumn, ...this.tableColumns];
      }
      return [...this.tableColumns];
    },

    user() {
      return this.$store.state.auth.user;
    },

    isQueueAdmin() {
      if(this.user){
        return +this.user.userRole === 7 || +this.user.userRole === 1;
      }
      return false;
    },

    selectedTenant(){
      return this.$store.state.selectedTenant;
    },

    canWithdrawCallers() {
      if(this.user){
        return this.selectedTenant.id === this.user.tenantId;
      }
      return false;
    }

  },
  watch: {
    searchText: debounce(function () {
      this.filter = this.searchText;
    }, 250),
    widgetName: debounce(function() {
      if(this.widgetName === this.title) return;
      this.$emit('nameUpdate', {name: this.widgetName, index: this.widgetIndex});
    }, 750)
  },
  methods: {

    getQueueName(data) {
      const { cellValue } = data;
      return this.queueNameKey[cellValue] ? this.queueNameKey[cellValue] : 'Unknown';
    },

    numberFormatter(data) {
      const { cellValue: number } = data;
      return number ? phoneNumberFormatter(number) : number;
    },

    //input is time in seconds. output is pretty time.
    timeFormatter(data) {
      const { cellValue: time } = data;
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);

      if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
      if (minutes > 0) {return minutes + 'm ' + seconds + 's';}
      if (seconds > 0) {return seconds + 's';}
      return '0';
    },

    removeWidget(){
      this.$emit('removeWidget', this.widgetIndex);
    },

    async withdrawCaller(call){

      const { channel, queueId } = call;

      try {
        const res = await fetch(`${apiV2Host}/queues/withdraw-caller?queueId=${queueId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${this.$store.state.auth.accessToken}`
          },
          body: JSON.stringify({ channel })
        });

        if(!res.ok) throw new Error(`Withdraw failed with status ${res.status}`);

      } catch (e) {
        console.log(e);
        this.$notify({
          title: "Failed",
          type: "error",
          message: "Failed to pick up call",
        });
      }
    },

  }
}

</script>
